// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2XxQS","activenavroute":"Navbar_activenavroute__32oUV"};